var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _g, _path6, _rect3, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOutlook = function SvgOutlook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 0.25,
    width: 12.5,
    height: 17.5,
    rx: 0.078,
    fill: "#1066B5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 0.25,
    width: 12.5,
    height: 17.5,
    rx: 0.078,
    fill: "url(#outlook_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#32A9E7",
    d: "M6.25 2.125h6.25v6.25H6.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#167EB4",
    d: "M6.25 8.375h6.25v6.25H6.25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#32A9E7",
    d: "M12.5 8.375h6.25v6.25H12.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#58D9FD",
    d: "M12.5 2.125h6.25v6.25H12.5z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "outlook_svg__c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 7,
    width: 15,
    height: 11
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.75h14.922c.043 0 .078.035.078.078v9.844a.078.078 0 0 1-.078.078H5.078A.078.078 0 0 1 5 17.672V7.75Z",
    fill: "url(#outlook_svg__b)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#outlook_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 7.75v2.5h-1.25v-2.5H20Z",
    fill: "#135298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 17.75V9L4.375 17.75H20Z",
    fill: "url(#outlook_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 17.75V9l15.625 8.75H5Z",
    fill: "url(#outlook_svg__e)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.742c0-.065.052-.117.117-.117h7.266c.065 0 .117.052.117.117v11.016a.117.117 0 0 1-.117.117H5V4.742Z",
    fill: "#000",
    fillOpacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 3.375,
    width: 11.25,
    height: 11.25,
    rx: 0.078,
    fill: "url(#outlook_svg__f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 9.043V8.94c0-1.8-1.295-3.064-3.115-3.064-1.83 0-3.135 1.273-3.135 3.082v.104c0 1.8 1.295 3.064 3.125 3.064 1.82 0 3.125-1.273 3.125-3.082Zm-1.473.018c0 1.194-.673 1.913-1.642 1.913-.97 0-1.652-.736-1.652-1.93v-.105c0-1.194.673-1.913 1.642-1.913.96 0 1.652.736 1.652 1.93v.105Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "outlook_svg__a",
    x1: 6.25,
    y1: 9,
    x2: 18.75,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "outlook_svg__b",
    x1: 5,
    y1: 15.731,
    x2: 20,
    y2: 15.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B366F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2657B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "outlook_svg__d",
    x1: 20,
    y1: 13.375,
    x2: 5,
    y2: 13.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44DCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#259ED0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "outlook_svg__e",
    x1: 5,
    y1: 13.375,
    x2: 20,
    y2: 13.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#259ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44DCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "outlook_svg__f",
    x1: 0,
    y1: 9,
    x2: 11.25,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })))));
};
export default SvgOutlook;